export const FETCH_ADMIN_SLIDE_EDIT_REQUEST = "FETCH_ADMIN_SLIDE_EDIT_REQUEST";
export const FETCH_ADMIN_SLIDE_EDIT_SUCCESS = "FETCH_ADMIN_SLIDE_EDIT_SUCCESS";
export const FETCH_ADMIN_SLIDE_EDIT_FAILURE = "FETCH_ADMIN_SLIDE_EDIT_FAILURE";